import React from 'react';
import PropTypes from 'prop-types';
import { BlockPicker } from 'react-color';
import { makeStyles } from '@material-ui/core/styles';

import { colors } from '@hydra/common/styles';

const colorSwatch = [
  colors.grey.dark,
  colors.grey.medium,
  colors.primary.darker,
  colors.primary.main,
  colors.success.dark,
  colors.success.main,
  colors.warning.dark,
  colors.warning.main,
  colors.error.dark,
  colors.error.main,
  colors.turquoise.darker,
  colors.turquoise.main,
  colors.emerald.darker,
  colors.emerald.main,
  colors.amethyst.darker,
  colors.amethyst.main,
  colors.competitor.dark,
  colors.competitor.main,
  colors.competitor.light
];

const useStyles = makeStyles(theme => ({
  picker: {
    marginBottom: theme.spacing(4),
    '&:last-child': {
      marginBottom: 0
    }
  },
  noShadow: {
    boxShadow: 'none !important'
  }
}));

const setNewColors = ({ at, value, colors, onChange }) => {
  const newColors = colors.map((oldValue, index) => ((index === at) ? value : oldValue));
  onChange(newColors);
};

const ColorPickers = ({ value, onChange }) => {
  const classes = useStyles();

  return value.map((color, index) => {
    return (
      <div key={index} className={classes.picker}>
        <BlockPicker
          width='100%'
          triangle='hide'
          onChange={e => setNewColors({ at: index, value: e.hex, colors: value, onChange })}
          color={color}
          colors={colorSwatch}
          className={classes.noShadow}
        />
      </div>
    );
  });
};

ColorPickers.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ColorPickers;
